import { FeatureFlags, formatFeatureFlagsForTracking } from "shared";
import { mt } from "./tracking";

export const setTealiumTestExperience = (featureFlags: FeatureFlags): void =>
  mt.trackView({
    test_experience: formatFeatureFlagsForTracking(featureFlags),
  });
